import { useEffect } from "react";
import dynamic from "next/dynamic";
import config from "@/lib/config";
import withMiddlewares from "@/middlewares/withMiddlewares";
import { CANVAS } from "@/apollo/queries/canvas";
import { CANVAS_PAGE_LIMIT } from "@/lib/constants";
import { useBreadcrumbs } from "@/hooks";
import routes from "@/lib/routes";
import StorePageMetaTags, {
  tags,
} from "@/components/MetaTags/StorePageMetaTags";
const Canvas = dynamic(() => import("@/components/Canvas"));

export default function Store() {
  const { setBreadcrumbs } = useBreadcrumbs();
  const key = config.canvas.store.vod;

  useEffect(() => {
    setBreadcrumbs([
      { text: "ホーム", href: routes.home },
      { text: "単品商品" },
    ]);
  }, []);

  return (
    <>
      <StorePageMetaTags />
      <Canvas idKey={key} />
    </>
  );
}

export const getServerSideProps = withMiddlewares(
  async ({ req }, { serverProps, error, apolloClient }) => {
    const idKey = config.canvas.store.vod;
    await apolloClient.query({
      query: CANVAS,
      variables: {
        idKey: idKey.toString(),
        offset: 0,
        limit: CANVAS_PAGE_LIMIT,
      },
    });

    const metatags = tags();
    return {
      props: {
        ...serverProps,
        error,
        metatags,
        initialApolloState: apolloClient.cache.extract(),
      },
    };
  }
);
